export default "__VITE_ASSET__C87F47Qq__"